import React from "react";
import { Box, HStack, Heading, Icon, Stack, Text } from "@chakra-ui/react";
import { RxDashboard } from "react-icons/rx";
import { HiArrowsUpDown } from "react-icons/hi2";
import { BiSupport } from "react-icons/bi";
import { Link, useLocation } from "react-router-dom";




const SideNav = () => {
  const location = useLocation()

  const isActiveLink = (link) => {
    return location.pathname === link;
  }

  const navLinks = [
    {
      icon: RxDashboard,
      text: "Dashboard",
      link:'/'
    },
    {
      icon: HiArrowsUpDown,
      text: "Transactions",
      link:'/transactions'
    },
  ];
  return (
    <div>
      <Stack 
      bg='white'
      justify='space-between' 
      boxShadow={{
        base:"none",
        lg:"lg"
      }} w={{
        base:"full",
        lg:"16rem"
      }} h="100vh">
        <Box>
        <Heading as="h1" fontSize="20px" pt="56px" textAlign="center">
          @DOSOMECODING
        </Heading>
        <Box mt="6" mx={3}>
          {navLinks.map((nav) => (
            <Link to={nav.link} key={nav.text}>
            <HStack
              borderRadius="10px"
              py={3}
              px={4}
              bg={isActiveLink(nav.link) ? "#F3F3F7" : "transparent"}
              color={isActiveLink(nav.link) ? "#171717" : "#797E82"}
              _hover={{
                bg: "#F3F3F7",
                color: "#171717",
              }}
            >
              <Icon as={nav.icon} />
              <Text fontSize="14px" fontWeight="medium">
                {nav.text}
              </Text>
            </HStack></Link>
          ))}
        </Box>
        </Box>
        <Box mt={6} mx={3} mb={6}>
        <Link to={'/support'}>
        <HStack
          borderRadius="10px"
          py={3}
          px={4}
          bg={isActiveLink('/support') ? "#F3F3F7" : "transparent"}
          color={isActiveLink('/support') ? "#171717" : "#797E82"}
          _hover={{
            bg: "#F3F3F7",
            color: "#171717",
          }}
        >
          <Icon as={BiSupport} />
          <Text fontSize="14px" fontWeight="medium">
            Support
          </Text>
        </HStack></Link>
        </Box>
      </Stack>
    </div>
  );
};

export default SideNav;
